import { createEffect, type Effect } from 'effector'
import { stateful } from '../../lib/stateful'
import type { Content } from '../content'
import {
  OVPBannerType,
  type OVPBannerCarousel,
  type OVPBannerContent,
  type OVPBannerParams,
  type OVPBannerTypeContent,
  type OVPBannerTypeLiveChannel,
  type OVPBannerTypeTvShow,
  type OVPCarouselType,
} from './index.h'

export {
  OVPBannerType,
  type OVPBannerCarousel,
  type OVPBannerContent,
  type OVPBannerParams,
  type OVPBannerTypeContent,
  type OVPBannerTypeLiveChannel,
  type OVPBannerTypeTvShow,
  type OVPCarouselType,
}

type GetPageParams = { limit?: number; offset?: number }
type GetManyParams = { order?: string }
type GetOneParams = { id: number }

// *
// * base API effects
// *

export const base = {
  getManyFx: createEffect<GetManyParams, OVPBannerCarousel[]>(),
  getOneFx: createEffect<GetOneParams, OVPBannerCarousel>(),
  getItemsFx: createEffect<GetOneParams & GetPageParams, Content[]>(),
}

export const getCarouselsFx: Effect<void, OVPBannerCarousel[]> = createEffect()

export const carousels = (initial?: GetManyParams) =>
  stateful({
    effect: base.getManyFx,
    initial,
    methods: {
      order: (order: string | undefined) => ({ order }),
    },
  })

export const carousel = (initial?: GetOneParams) =>
  stateful({
    effect: base.getOneFx,
    initial,
  })
